/* eslint-disable */
// 裁剪后的syp-client
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * @file utils
 * @author kaivean
 */
function assign() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var __assign = Object.assign || function __assign(t) {
        for (var s = void 0, i = 1, n = arguments.length; i < n; i++) {
            // eslint-disable-next-line prefer-rest-params
            s = arguments[i];
            for (var p in s) {
                if (Object.prototype.hasOwnProperty.call(s, p)) {
                    t[p] = s[p];
                }
            }
        }
        return t;
    };
    return __assign.apply(this, args);
}
function getUrlInfoFromURL(url) {
    if (URL && url) {
        try {
            var obj = new URL(url);
            if (obj.host !== undefined) {
                return {
                    protocol: obj.protocol,
                    host: obj.host,
                    pathname: obj.pathname,
                    ext: '',
                };
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    return;
}
function getUrlInfo(url) {
    var info = getUrlInfoFromURL(url);
    if (!info) {
        var parser = document.createElement('a');
        parser.href = url;
        info = {
            protocol: parser.protocol,
            host: parser.host || location.host,
            pathname: parser.pathname,
            ext: '',
        };
    }
    var split = info.pathname.split('.');
    info.ext = split[split.length - 1];
    return info;
}
function f$1(n) {
    return +n.toFixed(1);
}
function getResTiming(t) {
    return {
        wait: f$1(t.domainLookupStart - (t.navigationStart || t.fetchStart || t.startTime)),
        dns: f$1(t.domainLookupEnd - t.domainLookupStart),
        connect: f$1(t.connectEnd - t.connectStart),
        req: f$1(t.responseStart - t.requestStart),
        res: f$1(t.responseEnd - t.responseStart),
    };
}
function getxpath(el) {
    if (!el) {
        return { xpath: '' };
    }
    var xpath = [];
    while (el && el.nodeType === 1 && el !== el.parentNode) {
        var t = el.tagName.toLowerCase();
        if (el.getAttribute('id')) {
            t += '[#' + el.getAttribute('id') + ']';
        }
        else if (el.classList && el.classList.length) {
            t += '[.' + el.classList[el.classList.length - 1] + ']';
        }
        xpath.push(t);
        if (el === document.body) {
            break;
        }
        el = el.parentNode; // 修复缺陷检查
    }
    return {
        xpath: xpath.join('<'),
    };
}

/**
 * @file SpyClient
 * @author kaivean
 */
var defaultLogServer = 'https://sp1.baidu.com/5b1ZeDe5KgQFm2e88IuM_a/mwb2.gif?';
// 基础版本兼容非浏览器环境
var ver = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?)_/) : '';
var isLtIos14 = ver && ver[2] && (+ver[2] < 14);
function err(msg) {
    console.error("[SpyClient_log]".concat(msg));
    // throw new Error(msg);
}
function stringify(obj) {
    return Object.keys(obj).map(function (key) {
        var value = obj[key];
        if (typeof value === 'undefined') {
            value = '';
        }
        else if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
    }).join('&');
}
function isArray(arr) {
    return Object.prototype.toString.call(arr) === '[object Array]';
}
var SpyClient$1 = /** @class */ (function () {
    function SpyClient(option) {
        this.sample = {};
        this.markCache = {};
        if (!option.pid) {
            throw new Error('pid is required');
        }
        this.option = {
            pid: option.pid,
            lid: option.lid,
            check: option.check !== false,
            sample: option.sample,
            localCache: option.localCache,
            logServer: option.logServer || defaultLogServer,
        };
    }
    SpyClient.prototype.handle = function (logItem) {
        if (!this.check(logItem)) {
            return;
        }
        logItem = assign({
            pid: this.option.pid,
            lid: this.option.lid,
            ts: Date.now(),
            group: 'common',
        }, logItem);
        if (this.option.localCache) {
            this.option.localCache.addLog(logItem);
        }
        // 当前api设置了抽样，
        if (typeof logItem.sample === 'number') {
            if (Math.random() > logItem.sample) {
                return;
            }
        }
        else if (typeof this.option.sample === 'number' && Math.random() > this.option.sample) { // 否则，用全局抽样
            return;
        }
        delete logItem.sample;
        return logItem;
    };
    SpyClient.prototype.send = function (data, post) {
        if (post === void 0) { post = false; }
        var logItems = isArray(data) ? data : [data];
        var postData = [];
        for (var _i = 0, logItems_1 = logItems; _i < logItems_1.length; _i++) {
            var logItem = logItems_1[_i];
            logItem = this.handle(logItem);
            if (!logItem) {
                continue;
            }
            postData.push(logItem);
            // 期望通过post方式上传日志
            if (post) {
                continue;
            }
            var url = this.option.logServer + stringify(logItem);
            this.request(url);
        }
        if (post) {
            this.sendPost(postData);
        }
    };
    SpyClient.prototype.check = function (query) {
        if (!this.option.check) {
            return true;
        }
        var types = ['perf', 'except', 'dist', 'count'];
        if (types.indexOf(query.type) === -1) {
            err('type only is one of ' + types.join(', '));
            return false;
        }
        if (query.group && query.group.length > 30) {
            err('group length execeeds 30');
            return false;
        }
        var simpleReg = /^[a-zA-Z0-9-_]{0,30}$/;
        if (query.type === 'except') {
            if (!(typeof query.info.msg === 'string' && query.info.msg.length)) {
                err('info.msg field must be not empty and is String');
                return false;
            }
        }
        else {
            for (var _i = 0, _a = Object.keys(query.info); _i < _a.length; _i++) {
                var infoKey = _a[_i];
                if (!simpleReg.test(infoKey)) {
                    err("info.".concat(infoKey, " is unexpected. ")
                        + 'Length must be not more than 30. '
                        + 'Supported chars: a-zA-Z0-9-_');
                    return false;
                }
                var infoVal = query.info[infoKey];
                if (query.type === 'dist') {
                    if (infoVal.length > 30) {
                        err("info.".concat(infoKey, " value length execeeds 30 when type == 'dist'"));
                        return false;
                    }
                }
                else if (typeof infoVal !== 'number') {
                    err("info.".concat(infoKey, " value must be number"));
                    return false;
                }
            }
        }
        if (query.dim) {
            for (var _b = 0, _c = Object.keys(query.dim); _b < _c.length; _b++) {
                var dimKey = _c[_b];
                if (!simpleReg.test(dimKey)) {
                    err("dim key [".concat(dimKey, "] is unexpected. ")
                        + 'Length must be not more than 30. '
                        + 'Supported chars: a-zA-Z0-9-_');
                    return false;
                }
                var dimVal = query.dim[dimKey];
                if (!/^[a-zA-Z0-9\-_\*\.\s\/#\+@\&\u4e00-\u9fa5]{0,30}$/.test(dimVal)) {
                    err("dim.".concat(dimKey, " value [").concat(dimVal, "] is unexpected. ")
                        + 'Length must be not more than 30. '
                        + 'Supported chars: a-zA-Z0-9-_*. /#+@& and Chinese');
                    return false;
                }
            }
        }
        return true;
    };
    /**
     *
     * @param option 配置
     */
    SpyClient.prototype.sendPerf = function (option) {
        this.send(assign({
            type: 'perf',
        }, option));
    };
    /**
     *
     * @param option 错误配置项
     */
    SpyClient.prototype.sendExcept = function (option) {
        this.send(assign({
            type: 'except',
        }, option));
    };
    /**
     *
     * @param option 配置
     */
    SpyClient.prototype.sendDist = function (option) {
        this.send(assign({
            type: 'dist',
        }, option));
    };
    /**
     *
     * @param option 配置
     */
    SpyClient.prototype.sendCount = function (option) {
        this.send(assign({
            type: 'count',
        }, option));
    };
    /**
     *
     * @param e 错误实例
     * @param option 错误配置项
     */
    SpyClient.prototype.sendExceptForError = function (e, option) {
        var newOpt = assign({}, option);
        newOpt.info = assign({}, option.info || {}, {
            msg: e.message,
            stack: e.stack,
        });
        this.sendExcept(newOpt);
    };
    SpyClient.prototype.startMark = function (sign) {
        this.markCache[sign] = {
            start: Date.now(),
        };
    };
    SpyClient.prototype.endMark = function (sign) {
        if (this.markCache[sign]) {
            this.markCache[sign].total = Date.now() - this.markCache[sign].start;
            return this.markCache[sign].total;
        }
        return 0;
    };
    SpyClient.prototype.clearMark = function (sign) {
        if (this.markCache[sign]) {
            delete this.markCache[sign];
        }
    };
    SpyClient.prototype.getAllMark = function () {
        var ret = {};
        for (var _i = 0, _a = Object.keys(this.markCache); _i < _a.length; _i++) {
            var sign = _a[_i];
            ret[sign] = this.markCache[sign].total;
        }
        return ret;
    };
    SpyClient.prototype.clearAllMark = function () {
        this.markCache = {};
    };
    // send(data, true) 也能以post发送，但是会有严格校验
    // sendPost能以post发送，但没有校验
    SpyClient.prototype.sendPost = function (data) {
        var logItems = isArray(data) ? data : [data];
        var first = logItems[0];
        // 需要在页面暴漏出来pid等基本信息，方式调试查看基本信息与兼容目前的监控
        var query = {
            pid: first.pid,
            type: first.type,
            group: first.group,
        };
        var url = this.option.logServer + stringify(query);
        this.request(url, data);
    };
    // 有data时，意味着要用post发送请求
    SpyClient.prototype.request = function (url, data) {
        if (!(!isLtIos14
            && navigator
            && navigator.sendBeacon
            && navigator.sendBeacon(url, data ? JSON.stringify(data) : undefined))) {
            if (data) {
                this.fetch(url, data);
            }
            else {
                (new Image()).src = url;
            }
        }
    };
    SpyClient.prototype.fetch = function (url, data) {
        if (!fetch) {
            err('Global fetch method doesn\'t exist');
            return;
        }
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
    };
    return SpyClient;
}());

/**
 * @file 简单的公共数据模块，内部模块之间数据交换
 * @author kaivean
 */
function setData(key, value) {
}

/**
 * @file LCP
 * @author kaivean
 */
var spyclient = window.__spyHead;
var entryType = 'largest-contentful-paint';
var LCP = /** @class */ (function () {
    function LCP() {
        var _this = this;
        this.observer = null;
        if (!window.PerformanceObserver) {
            return;
        }
        if (spyclient && spyclient.entryMap && spyclient.entryMap[entryType]) {
            this.handle(spyclient.entryMap[entryType]);
        }
        try {
            // 仅在 img,image,svg,video,css url, block element with text nodes
            this.observer = new PerformanceObserver(function (list) {
                _this.handle(list.getEntries());
            });
            this.observer.observe({ entryTypes: [entryType] });
        }
        catch (e) { }
    }
    LCP.prototype.listenLCP = function (cb) {
        this.cb = cb;
        this.callCB();
    };
    LCP.prototype.callCB = function () {
        if (this.finalValue && this.cb) {
            this.cb({ lcp: this.finalValue });
        }
    };
    LCP.prototype.load = function () {
        this.observer && this.observer.takeRecords && this.observer.takeRecords();
        this.finalValue = this.value;
        setData('lcp', this.value);
        this.callCB();
        this.destroy();
    };
    LCP.prototype.destroy = function () {
        this.observer && this.observer.disconnect();
        this.observer = null;
    };
    LCP.prototype.handle = function (entries) {
        var _this = this;
        entries.map(function (entry) {
            _this.value = entry.renderTime || entry.loadTime;
        });
    };
    return LCP;
}());

/**
 * @file LCP
 * @author kaivean
 */
var Timing = /** @class */ (function () {
    function Timing() {
    }
    // constructor() {}
    Timing.prototype.listenTiming = function (cb) {
        if (!window.performance || !window.performance.timing) {
            // debug('no performance.timing api');
            return;
        }
        this.cb = cb;
    };
    Timing.prototype.load = function () {
        var _this = this;
        setTimeout(function () {
            _this.cb && _this.cb(_this.getMetric());
        }, 500);
    };
    Timing.prototype.getMetric = function () {
        var metric = {};
        var timing = window.performance.timing;
        var startTime = timing.navigationStart;
        // 基础信息
        metric.dns = timing.domainLookupEnd - timing.domainLookupStart;
        metric.tcp = timing.connectEnd - timing.connectStart;
        metric.request = timing.responseStart - timing.requestStart;
        metric.response = timing.responseEnd - timing.responseStart;
        // 这是从页面部分数据返回，浏览器开始解析doc元素到最底部的script脚本解析执行完成
        // 脚本里触发的异步或绑定了更靠后的事件，不再纳入范围内
        metric.parseHtml = timing.domInteractive - timing.domLoading;
        // 很多事件绑定是在domContentLoaded事件里的，所以等其结束，一般页面元素的事件绑定好了，用户可以正确交互
        // 当然存在在该加载事件之后绑定元素事件情况，但不再此考虑范围内
        metric.domReady = timing.domContentLoadedEventEnd - startTime;
        metric.loadEventHandle = timing.loadEventEnd - timing.loadEventStart;
        // 基本该做的都做完，资源也都加载完成了
        // 当然在onload事件处理函数里启动了异步方法，不再纳入范围内
        metric.load = timing.loadEventEnd - startTime;
        // 浏览器首次绘制与首次内容绘制， ios低版本无getEntriesByType api
        if (performance.getEntriesByType) {
            var paintEntries = performance.getEntriesByType('paint');
            if (paintEntries && paintEntries.length) {
                paintEntries.forEach(function (_a) {
                    var name = _a.name, duration = _a.duration, startTime = _a.startTime;
                    var time = Math.ceil(duration + startTime);
                    if (name === 'first-paint') {
                        metric.fp = time;
                    }
                    if (name === 'first-contentful-paint') {
                        metric.fcp = time;
                    }
                });
            }
        }
        // 端首次绘制与首屏
        if (timing.domFirstPaint) {
            metric.t7FirstPaint = timing.domFirstPaint - startTime;
        }
        if (timing.domFirstScreenPaint) {
            metric.t7FirstScreen = timing.domFirstScreenPaint - startTime;
        }
        return metric;
    };
    return Timing;
}());

var ResType;
(function (ResType) {
    ResType["JS"] = "js";
    ResType["CSS"] = "css";
    ResType["IMG"] = "img";
    ResType["FONT"] = "font";
})(ResType || (ResType = {}));

// 字体
// svg使用场景比较灵活，可能作为一种字体格式，也可能当做图片使用
// 但因woff在所有现代浏览器中都支持，在css中使用iconfont时
// 往往优先加载woff格式字体文件，所以这里将svg划分为图片一类
var FontsTypes;
(function (FontsTypes) {
    FontsTypes[FontsTypes["ttf"] = 0] = "ttf";
    FontsTypes[FontsTypes["eot"] = 1] = "eot";
    FontsTypes[FontsTypes["woff"] = 2] = "woff";
    FontsTypes[FontsTypes["woff2"] = 3] = "woff2";
})(FontsTypes || (FontsTypes = {}));
// 忽略图片
// 下述图片路径往往是用来进行日志统计，不是正常图片
var ignoreDefaultPaths = [
    '/mwb2.gif',
];
function ignorePath(url, paths) {
    for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
        var path = paths_1[_i];
        if (url.indexOf(path) > -1) {
            return true;
        }
    }
    return false;
}
function f(n) {
    return +n.toFixed(1);
}
var Resource = /** @class */ (function () {
    function Resource() {
        this.trigger = 'load';
        this.jsList = [];
        this.cssList = [];
        this.imgList = [];
        this.fontList = [];
        this.hostList = {};
        this.bigImgList = {};
        this.httpResList = {};
        this.slowList = {};
        this.resOption = { ignorePaths: [], trigger: 'load' };
        this.bigImgOption = { ignorePaths: [], maxSize: 150 * 1024, trigger: 'load' };
        this.httpResOption = { ignorePaths: [], trigger: 'load' };
        this.slowOption = { ignorePaths: [], trigger: 'load', threshold: 1000 };
    }
    Resource.prototype.check = function () {
        return performance && performance.getEntriesByType;
    };
    Resource.prototype.listenResource = function (cb, option) {
        if (option === void 0) { option = {}; }
        if (!this.check()) {
            return;
        }
        this.resOption = assign(this.resOption, option);
        this.trigger = this.resOption.trigger;
        this.cb = cb;
    };
    Resource.prototype.listenBigImg = function (cb, option) {
        if (option === void 0) { option = {}; }
        if (!this.check()) {
            return;
        }
        this.bigImgOption = assign(this.bigImgOption, option);
        this.trigger = this.bigImgOption.trigger;
        this.bigImgCB = cb;
    };
    Resource.prototype.listenHttpResource = function (cb, option) {
        if (option === void 0) { option = {}; }
        if (!this.check()) {
            return;
        }
        this.httpResOption = assign(this.httpResOption, option);
        this.trigger = this.httpResOption.trigger;
        this.httpResCB = cb;
    };
    Resource.prototype.listenSlowResource = function (cb, option) {
        if (option === void 0) { option = {}; }
        if (!this.check()) {
            return;
        }
        this.slowOption = assign(this.slowOption, option);
        this.trigger = this.slowOption.trigger;
        this.slowResCB = cb;
    };
    Resource.prototype.report = function () {
        var _this = this;
        var metricRes = this.getMetric();
        if (metricRes) {
            var metric = metricRes.metric, hostMetric = metricRes.hostMetric;
            this.cb && this.cb(metric, hostMetric);
        }
        if (this.bigImgCB) {
            // 发送大图监控数据
            if (typeof window.requestIdleCallback === 'function' && Object.keys(this.bigImgList).length) {
                window.requestIdleCallback(function () {
                    for (var _i = 0, _a = Object.keys(_this.bigImgList); _i < _a.length; _i++) {
                        var host = _a[_i];
                        for (var _b = 0, _c = _this.bigImgList[host]; _b < _c.length; _b++) {
                            var entry = _c[_b];
                            var timing = entry.timing;
                            var type = entry.type;
                            try {
                                var img = document.body.querySelector('img[src="' + timing.name + '"]');
                                _this.bigImgCB({
                                    msg: timing.name,
                                    dur: timing.duration,
                                    xpath: getxpath(img).xpath,
                                    host: host,
                                    type: type,
                                });
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                });
            }
        }
        if (this.httpResCB) {
            // 发送http资源监控数据
            if (typeof window.requestIdleCallback === 'function' && Object.keys(this.httpResList).length) {
                window.requestIdleCallback(function () {
                    for (var _i = 0, _a = Object.keys(_this.httpResList); _i < _a.length; _i++) {
                        var host = _a[_i];
                        for (var _b = 0, _c = _this.httpResList[host]; _b < _c.length; _b++) {
                            var entry = _c[_b];
                            var timing = entry.timing;
                            var type = entry.type;
                            try {
                                var img = document.body.querySelector('[src="' + timing.name + '"]');
                                _this.httpResCB({
                                    msg: timing.name,
                                    dur: timing.duration,
                                    xpath: getxpath(img).xpath,
                                    host: host,
                                    type: type,
                                });
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                });
            }
        }
        if (this.slowResCB) {
            // 发送慢资源监控数据
            if (typeof window.requestIdleCallback === 'function' && Object.keys(this.slowList).length) {
                window.requestIdleCallback(function () {
                    for (var _i = 0, _a = Object.keys(_this.slowList); _i < _a.length; _i++) {
                        var host = _a[_i];
                        for (var _b = 0, _c = _this.slowList[host]; _b < _c.length; _b++) {
                            var entry = _c[_b];
                            var timing = entry.timing;
                            var type = entry.type;
                            try {
                                var img = document.body.querySelector('[src="' + timing.name + '"]');
                                var info = getResTiming(timing);
                                _this.slowResCB(__assign(__assign({}, info), { dur: timing.duration, msg: timing.name, xpath: getxpath(img).xpath, host: host, type: type }));
                            }
                            catch (e) {
                                console.error(e);
                            }
                        }
                    }
                });
            }
        }
    };
    Resource.prototype.load = function () {
        var _this = this;
        if (this.trigger !== 'load') {
            return;
        }
        if (!this.check()) {
            return;
        }
        setTimeout(function () {
            _this.report();
        }, 500);
    };
    Resource.prototype.leave = function () {
        if (this.trigger !== 'leave') {
            return;
        }
        this.report();
    };
    Resource.prototype.push = function (type, list, timing, urlInfo) {
        if (!ignorePath(urlInfo.pathname, this.resOption.ignorePaths || [])) {
            list.push(timing);
            this.pushWithHost(type, this.hostList, timing, urlInfo);
        }
        if (!ignorePath(urlInfo.pathname, this.slowOption.ignorePaths || [])) {
            if (timing.duration > this.slowOption.threshold) {
                this.pushWithHost(type, this.slowList, timing, urlInfo);
            }
        }
    };
    Resource.prototype.pushWithHost = function (type, list, timing, urlInfo) {
        var host = urlInfo.host;
        if (!list[host]) {
            list[host] = [];
        }
        list[host].push({
            timing: timing,
            type: type,
        });
    };
    Resource.prototype.collectHttpResInHttps = function (type, timing, urlInfo) {
        if (location.protocol === 'https:'
            && timing.name.indexOf('http://') === 0
            && !ignorePath(urlInfo.pathname, this.httpResOption.ignorePaths || [])) {
            this.pushWithHost(type, this.httpResList, timing, urlInfo);
        }
    };
    // 有些jsonp也属于script，这里只统计js后缀的文件
    Resource.prototype.addScript = function (timing, urlInfo) {
        if (urlInfo.ext === 'js') {
            if (timing.decodedBodySize !== 0) {
                this.push('js', this.jsList, timing, urlInfo);
            }
        }
    };
    // 暂时将css文件或代码块发起的请求归位三类（主要为这两类）
    // 1、加载字体
    // 2、加载背景图（图片不容易区分，有的没有明确后缀名）
    // 3、光标文件（后缀为.cur，这里也划分为图片）
    // （svg当做图片，前述已说明）
    Resource.prototype.addResFromCss = function (timing, urlInfo) {
        if (urlInfo.ext && FontsTypes.hasOwnProperty(urlInfo.ext)) {
            this.push('font', this.fontList, timing, urlInfo);
        }
        else {
            this.addImg(timing, urlInfo);
        }
    };
    // link一般加载css资源
    // 也可以通过preload可以预下载一些资源
    // 这里只统计js类型的preload
    Resource.prototype.addLink = function (timing, urlInfo) {
        if (urlInfo.ext === 'css') {
            this.push('css', this.cssList, timing, urlInfo);
        }
        // preload as script
        else if (urlInfo.ext === 'js') {
            this.push('js', this.jsList, timing, urlInfo);
        }
    };
    Resource.prototype.addImg = function (timing, urlInfo) {
        this.push('img', this.imgList, timing, urlInfo);
        // 大于指定size的图片采集
        if (timing.decodedBodySize > (this.bigImgOption.maxSize || 0)
            && !ignorePath(urlInfo.pathname, this.bigImgOption.ignorePaths || [])) {
            this.pushWithHost('img', this.bigImgList, timing, urlInfo);
        }
    };
    Resource.prototype.handleTimings = function (list) {
        var len = list.length;
        for (var i = 0; i < len; i++) {
            var timing = list[i];
            var urlInfo = getUrlInfo(timing.name);
            if (ignorePath(urlInfo.pathname, ignoreDefaultPaths)) {
                continue;
            }
            switch (list[i].initiatorType) {
                case 'script':
                    this.addScript(timing, urlInfo);
                    break;
                case 'css':
                    this.addResFromCss(timing, urlInfo);
                    break;
                case 'img':
                    this.addImg(timing, urlInfo);
                    break;
                case 'link':
                    this.addLink(timing, urlInfo);
                    break;
                case 'audio':
                    this.collectHttpResInHttps('audio', timing, urlInfo);
                    break;
                case 'video':
                    this.collectHttpResInHttps('video', timing, urlInfo);
                    break;
            }
        }
    };
    Resource.prototype.getNumAndSize = function (type, list) {
        var obj = {};
        var num = type + 'Num';
        var size = type + 'Size';
        var transferSize = type + 'TransferSize';
        var cacheRate = type + 'CacheRate';
        var duration = type + 'Duration';
        obj[num] = 0;
        obj[size] = 0;
        obj[transferSize] = 0;
        var totalDurationTime = 0;
        list.forEach(function (timing) {
            obj[num]++;
            obj[size] += (timing.decodedBodySize / 1024);
            obj[transferSize] += (timing.transferSize / 1024);
            totalDurationTime += timing.duration;
        });
        obj[duration] = f(obj[num] > 0 ? totalDurationTime / obj[num] : 0);
        if (obj[size]) {
            var diff = obj[size] - obj[transferSize];
            obj[cacheRate] = f(diff >= 0 ? 100 * diff / obj[size] : 0);
        }
        obj[size] = f(obj[size]);
        obj[transferSize] = f(obj[transferSize]);
        return obj;
    };
    Resource.prototype.getMetric = function () {
        // 原来代码
        var mainPageTiming = performance.getEntriesByType('navigation')[0];
        var resourceTimings = performance.getEntriesByType('resource');
        if (mainPageTiming && resourceTimings && resourceTimings.length) {
            this.handleTimings(resourceTimings);
            var metric = __assign(__assign(__assign(__assign({}, this.getNumAndSize(ResType.JS, this.jsList)), this.getNumAndSize(ResType.CSS, this.cssList)), this.getNumAndSize(ResType.IMG, this.imgList)), this.getNumAndSize(ResType.FONT, this.fontList));
            // 主文档大小
            var pageTiming = mainPageTiming;
            metric.docSize = f(pageTiming.decodedBodySize / 1024);
            metric.docTransferSize = f(pageTiming.transferSize / 1024);
            metric.headerSize = f((pageTiming.transferSize - pageTiming.encodedBodySize || 0) / 1024);
            metric.allSize = f(metric.docSize
                + metric.jsSize
                + metric.cssSize
                + metric.imgSize
                + metric.fontSize);
            metric.allTransferSize = f(metric.docTransferSize
                + metric.jsTransferSize
                + metric.cssTransferSize
                + metric.imgTransferSize
                + metric.fontTransferSize);
            var hostMetric = {};
            for (var _i = 0, _a = Object.keys(this.hostList); _i < _a.length; _i++) {
                var host = _a[_i];
                var timings = this.hostList[host].map(function (item) { return item.timing; });
                hostMetric[host] = this.getNumAndSize('host', timings);
            }
            return { metric: metric, hostMetric: hostMetric };
        }
        return;
    };
    return Resource;
}());

/**
 * @file SpyClient
 * @author kaivean
 */
// import Memory from './module/memory';
// import NavigatorInfo from './module/navigatorInfo';
// import Longtask from './module/longtask';
var SpyClient = /** @class */ (function (_super) {
    __extends(SpyClient, _super);
    function SpyClient(option) {
        var _this = _super.call(this, option) || this;
        _this.modules = [];
        // this.register(new FID());
        _this.register(new LCP());
        // this.register(new LayoutShift());
        // this.register(new TTI());
        _this.register(new Timing());
        _this.register(new Resource());
        // this.register(new Memory());
        // this.register(new NavigatorInfo());
        // this.register(new Longtask());
        _this.visibilitychangeCB = _this.visibilitychangeCB.bind(_this);
        _this.load = _this.load.bind(_this);
        _this.leave = _this.leave.bind(_this);
        if (document.readyState === 'complete') {
            _this.load();
        }
        else {
            window.addEventListener('load', _this.load);
        }
        document.addEventListener('visibilitychange', _this.visibilitychangeCB);
        window.addEventListener('beforeunload', _this.leave, false);
        window.addEventListener('unload', _this.leave, false);
        _this.handleHead();
        return _this;
    }
    SpyClient.prototype.handleHead = function () {
        var _this = this;
        if (this.option.localCache) {
            var spyHead = window.__spyHead;
            if (spyHead && spyHead.winerrors) {
                for (var index = 0; index < spyHead.winerrors.length; index++) {
                    var obj = spyHead.winerrors[index];
                    this.option.localCache.addLog(obj);
                }
                // Head发送的异常，也保存一份到本地，主要是JS错误和资源加载异常
                spyHead.interceptor = function (obj) {
                    _this.option.localCache.addLog(obj);
                };
            }
        }
    };
    SpyClient.prototype.listenLCP = function (cb) {
        this.invoke('listenLCP', cb);
    };
    SpyClient.prototype.listenResource = function (cb, option) {
        this.invoke('listenResource', cb, option);
    };
    SpyClient.prototype.listenBigImg = function (cb, option) {
        this.invoke('listenBigImg', cb, option);
    };
    SpyClient.prototype.listenHttpResource = function (cb, option) {
        this.invoke('listenHttpResource', cb, option);
    };
    SpyClient.prototype.listenSlowResource = function (cb, option) {
        this.invoke('listenSlowResource', cb, option);
    };
    SpyClient.prototype.listenTiming = function (cb) {
        this.invoke('listenTiming', cb);
    };
    SpyClient.prototype.invoke = function (name, cb, option) {
        for (var index = 0; index < this.modules.length; index++) {
            var mod = this.modules[index];
            if (typeof mod[name] === 'function') {
                return mod[name].apply(mod, [cb, option]);
            }
        }
        console.error('no method', name);
    };
    SpyClient.prototype.register = function (mod) {
        this.modules.push(mod);
    };
    SpyClient.prototype.load = function () {
        for (var index = 0; index < this.modules.length; index++) {
            var mod = this.modules[index];
            mod.load && mod.load();
        }
    };
    SpyClient.prototype.leave = function () {
        for (var index = 0; index < this.modules.length; index++) {
            var mod = this.modules[index];
            mod.leave && mod.leave();
        }
    };
    SpyClient.prototype.destroy = function () {
        for (var index = 0; index < this.modules.length; index++) {
            var mod = this.modules[index];
            mod.destroy && mod.destroy();
        }
        document.removeEventListener('visibilitychange', this.visibilitychangeCB);
        window.removeEventListener('load', this.load);
        window.removeEventListener('beforeunload', this.leave);
        window.removeEventListener('unload', this.destroy);
    };
    SpyClient.prototype.visibilitychangeCB = function () {
        if (document.visibilityState === 'hidden') {
            this.leave();
        }
    };
    return SpyClient;
}(SpyClient$1));

export { SpyClient as default };
